export const MANUAL_URL =
  "https://drive.google.com/file/d/1venhBRfJ3H7WQFcJVIMoXLhIoPBEL7lp/view?usp=sharing";
